import { gql } from '@apollo/client';

/**
 * Fragment canónico de GenericOrder — superset de los subselects usados por
 * las mutations legacy (CREATE_NEW_GENERIC_ORDER, UPDATE_GENERIC_ORDER,
 * UPDATE_GENERIC_ORDER_RELATIONSHIPS).
 *
 * Se usa en la respuesta de `SAVE_GENERIC_ORDER`. Ver
 * PLAN-SAVE-ENTITY-UNIFIED.md §2.4. GenericOrder es top-level (sin parent).
 */
export const NEW_GENERIC_ORDER = gql`
  fragment NewGenericOrder on GenericOrder {
    id

    # ─── Índices + estado ───
    indexExpedition
    indexType
    state

    # ─── Tipo B denormalizado (coherente con Order paralela) ───
    concessionIDs
    roadIDs
    teamIDs
    pkInitKm
    pkInitMeter
    pkEndKm
    pkEndMeter
    track
    direction
    margin
    lane
    creationDate
    registerInitDate

    # ─── Entidad doble ───
    orderIDs
  }
`;
